export const useSelectorHover = (selector) => {
  const ele = useSelectorElement(selector)

  const hovering = ref(false)

  const onHover = () => {
    hovering.value = true
  }
  const onLeave = () => {
    hovering.value = false
  }
  watch(
    () => ele.value,
    (newVal, oldVal) => {
      if (oldVal) {
        oldVal.removeEventListener("mouseenter", onHover)
        oldVal.removeEventListener("mouseleave", onLeave)
      } else if (newVal) {
        ele.value.addEventListener("mouseenter", onHover)
        ele.value.addEventListener("mouseleave", onLeave)
      }
    }
  )
  onBeforeUnmount(() => {
    if (ele.value) {
      ele.value.removeEventListener("mouseenter", onHover)
      ele.value.removeEventListener("mouseleave", onLeave)
    }
  })

  return hovering
}
